import { FC, Fragment, useEffect } from "react";
import Cookies from "js-cookie";
// Hooks
import useADCampaignSignup from "app/hooks/useADCampaignSignup";
import useToggle from "app/hooks/useToggle";
// Context
import { UploadProvider } from "app/context/UploadFiles";
// Components
import { AppLoader } from "app/components/Utilities";
import CampaignUnavailable from "./CampaignUnavailable";
import Header from "./Header";
import Footer from "./Footer";
import UploadDocuments from "./UploadDocuments";
import MainPage from "./MainPage";
import SignupFormDialog from "./SignupFormDialog";
// MixPanel
import MixpanelTracks from "app/types/MixpanelTracks";
import Mixpanel from "app/services/Mixpanel.service";

const CampaignSignupPage:FC = () => {
  const {
    pageData,
    isRegistrationAllowed, isSettingsFetching,
    isLoading, error, handleSignup
  } = useADCampaignSignup();

  const caseId = Cookies.get('caseId');
  const showDocumentUpload = Boolean(caseId);

  const { open, toggle } = useToggle();

  useEffect(() => {
    Mixpanel.track(MixpanelTracks.CampaignLandingPageOpened);
  }, []);

  if (isSettingsFetching) return <AppLoader />;
  return (
    <Fragment>
      <Header />
      {isRegistrationAllowed ? (
        <Fragment>
          {showDocumentUpload ? (
            <UploadProvider features={{ allowFileCollection: false, allowFileComment: false }}>
              <UploadDocuments />
            </UploadProvider>
          ) : (
            <Fragment>
              <MainPage pageData={pageData} onOpen={toggle} />
              {open ? (
                <SignupFormDialog
                  open={open}
                  onClose={toggle}
                  isLoading={isLoading}
                  error={error}
                  handleSignup={handleSignup}
                />
              ) : null}
            </Fragment>
          )}
        </Fragment>
      ) : <CampaignUnavailable />}
      <Footer />
    </Fragment>
  );
};

export default CampaignSignupPage;
